// Copyright (c) 2016 Deere & Company

import Dealer from '@deere/cps-it.warranty-model-factory/lib/dealer';
import t from 'tcomb';

const Dealers = t.list(Dealer, 'Dealers');

export const getDefaultState = () => new Dealers([]);

export default Dealers;



// WEBPACK FOOTER //
// ./src/product/shared/state/dealers.js